import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import { categories } from '@/mocks/categories';
import { getFeaturedSites, sites } from '@/mocks/sites';
import { getLatestArticles } from '@/mocks/articles';

export default function Home() {
  const featuredSites = getFeaturedSites();
  const latestArticles = getLatestArticles(6);
  const hotSites = [...sites].sort((a, b) => parseFloat(b.visitors.replace('万', '')) - parseFloat(a.visitors.replace('万', ''))).slice(0, 8);

  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '成人导航',
    url: 'https://adultnav.example.com',
    description: '成人导航为您提供最全面的成人内容导航服务，精选优质成人网站、影视资源、娱乐平台一站式导航，让您快速找到所需成人内容资源，安全、便捷、高效的成人导航体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://adultnav.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="成人导航-最全成人内容导航平台"
        description="成人导航为您提供最全面的成人内容导航服务，精选优质成人网站、影视资源、娱乐平台一站式导航，让您快速找到所需成人内容资源，安全、便捷、高效的成人导航体验。"
        keywords="成人导航,成人网站导航,成人内容导航,成人资源导航,成人影视导航,成人娱乐导航,成人平台推荐"
        canonicalUrl="/"
        schemaData={homepageSchema}
      />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main>
          <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20geometric%20background%20with%20deep%20black%20and%20charcoal%20tones%2C%20subtle%20gradients%20of%20warm%20amber%20and%20gold%20light%20rays%20emanating%20from%20center%2C%20premium%20cinematic%20atmosphere%2C%20elegant%20minimalist%20aesthetic%2C%20soft%20particles%20floating%2C%20no%20text&width=1800&height=900&seq=hero-bg-home-01&orientation=landscape"
                alt="成人导航平台背景"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-950"></div>
            </div>

            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-4xl mx-auto">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
                  <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                  <span className="text-xs text-primary-400 font-medium">已收录 600+ 优质网站</span>
                </div>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-5 leading-tight">
                  最全成人内容
                  <span className="text-primary-400">导航平台</span>
                </h1>
                <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto mb-8 leading-relaxed">
                  精选优质成人网站、影视资源、娱乐平台一站式导航，让您快速找到所需成人内容资源，安全、便捷、高效的成人导航体验
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <Link
                    to="/category/video-platforms"
                    className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full text-sm transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    开始浏览
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-8 py-3 border border-foreground-300/30 hover:border-primary-500/50 text-foreground-300 hover:text-primary-400 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>

                <div className="mt-12 flex flex-wrap items-center justify-center gap-8">
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">600+</div>
                    <div className="text-xs text-foreground-500 mt-1">收录网站</div>
                  </div>
                  <div className="w-px h-10 bg-foreground-300/20"></div>
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">8</div>
                    <div className="text-xs text-foreground-500 mt-1">内容分类</div>
                  </div>
                  <div className="w-px h-10 bg-foreground-300/20"></div>
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">50万+</div>
                    <div className="text-xs text-foreground-500 mt-1">月访问用户</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
              <i className="ri-arrow-down-line text-foreground-400 text-2xl"></i>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
                  内容分类导航
                </h2>
                <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                  八大内容分类，覆盖视频、直播、图片、社区、小说、交友、游戏、工具等全领域
                </p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {categories.map((cat, idx) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group relative bg-background-900 border border-background-800/60 hover:border-primary-500/30 rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                    style={{ animationDelay: `${idx * 50}ms` }}
                  >
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                      <i className={`${cat.icon} text-xl md:text-2xl text-primary-400`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1.5">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                      {cat.description}
                    </p>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-xs text-foreground-600">{cat.count} 个网站</span>
                      <span className="w-7 h-7 rounded-full bg-background-800 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors duration-300">
                        <i className="ri-arrow-right-line text-xs text-foreground-400 group-hover:text-primary-400"></i>
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900/50">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-4">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
                    精选推荐
                  </h2>
                  <p className="text-sm text-foreground-500">编辑精选优质成人平台，品质保证</p>
                </div>
                <Link
                  to="/category/video-platforms"
                  className="text-sm text-primary-400 hover:text-primary-300 flex items-center gap-1 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {featuredSites.map((site) => (
                  <div
                    key={site.id}
                    className="group bg-background-900 border border-background-800/60 hover:border-accent-500/30 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                    data-product-shop
                  >
                    <div className="relative h-40 md:h-44 overflow-hidden">
                      <img
                        src={site.thumbnail}
                        alt={site.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 bg-primary-500 text-background-950 text-xs font-semibold rounded-md">
                          推荐
                        </span>
                      </div>
                      <div className="absolute top-3 right-3">
                        <span className="px-2 py-1 bg-background-950/80 backdrop-blur-sm text-accent-400 text-xs rounded-md">
                          ★ {site.rating}
                        </span>
                      </div>
                    </div>
                    <div className="p-4 md:p-5">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-2">{site.name}</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                        {site.description}
                      </p>
                      <div className="flex flex-wrap gap-1.5 mb-3">
                        {site.tags.map((tag) => (
                          <span
                            key={tag}
                            className="px-2 py-0.5 bg-secondary-500/10 text-secondary-400 text-[10px] rounded-md"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-foreground-600 flex items-center gap-1">
                          <i className="ri-user-line text-[10px]"></i> {site.visitors} 访问
                        </span>
                        <a
                          href={site.url}
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          className="px-4 py-1.5 bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-950 text-xs rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                        >
                          访问网站
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-4">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
                    热门网站排行
                  </h2>
                  <p className="text-sm text-foreground-500">按访问量排序，发现最受欢迎的成人平台</p>
                </div>
              </div>

              <div className="bg-background-900 border border-background-800/60 rounded-2xl overflow-hidden">
                {hotSites.map((site, idx) => (
                  <div
                    key={site.id}
                    className={`flex items-center gap-4 p-4 md:p-5 transition-colors duration-200 hover:bg-background-800/40 cursor-pointer ${
                      idx < hotSites.length - 1 ? 'border-b border-background-800/60' : ''
                    }`}
                  >
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                      idx < 3
                        ? 'bg-primary-500 text-background-950'
                        : 'bg-background-800 text-foreground-500'
                    }`}>
                      {idx + 1}
                    </div>
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg overflow-hidden flex-shrink-0">
                      <img src={site.thumbnail} alt={site.name} className="w-full h-full object-cover object-top" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-sm font-semibold text-foreground-100 truncate">{site.name}</h4>
                        <span className="text-accent-400 text-xs">★ {site.rating}</span>
                      </div>
                      <p className="text-xs text-foreground-500 truncate">{site.description}</p>
                    </div>
                    <div className="flex items-center gap-3 flex-shrink-0">
                      <span className="text-xs text-foreground-600 hidden sm:block">{site.visitors} 访问</span>
                      <a
                        href={site.url}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="px-4 py-1.5 bg-primary-500/15 hover:bg-primary-500 text-primary-400 hover:text-background-950 text-xs rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                      >
                        访问
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900/50">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-4">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
                    最新资讯
                  </h2>
                  <p className="text-sm text-foreground-500">成人内容行业动态与平台使用指南</p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {latestArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-900 border border-background-800/60 hover:border-primary-500/30 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="relative h-44 md:h-48 overflow-hidden">
                      <img
                        src={article.thumbnail}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-[10px] text-foreground-600">{article.date}</span>
                        <span className="text-[10px] text-foreground-600">{article.readTime}</span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-2 line-clamp-2 group-hover:text-primary-400 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-7xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
                为什么选择成人导航？
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto mb-10 md:mb-14">
                我们致力于为用户提供最优质的成人内容导航体验
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '严格筛选收录网站，确保访问安全无风险' },
                  { icon: 'ri-flashlight-line', title: '极速访问', desc: '智能路由优化，一键直达目标网站' },
                  { icon: 'ri-stack-line', title: '海量资源', desc: '覆盖全品类成人内容，持续更新收录' },
                  { icon: 'ri-user-heart-line', title: '用户至上', desc: '以用户体验为核心，不断优化服务' },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="bg-background-900 border border-background-800/60 rounded-2xl p-6 md:p-7 text-center"
                  >
                    <div className="w-14 h-14 rounded-2xl bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
                      <i className={`${item.icon} text-2xl text-accent-400`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-100 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900/50">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
                开始探索
              </h2>
              <p className="text-sm text-foreground-500 mb-8">
                立即加入，发现最适合您的成人内容平台
              </p>
              <Link
                to="/category/video-platforms"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full text-sm transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                立即开始浏览
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}